import * as React from 'react';
export const dropboxSvg = React.forwardRef(function dropboxSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#0061FE',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: '#F7F5F2',
      d: 'm10.328 7-5.671 3.563 5.671 3.562L16 10.562l5.672 3.563 5.671-3.563L21.672 7 16 10.563 10.328 7Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: '#F7F5F2',
      d: 'm10.328 21.25-5.671-3.562 5.671-3.563L16 17.688l-5.672 3.562ZM16 17.688l5.672-3.563 5.671 3.563-5.671 3.562L16 17.688ZM16 26l-5.672-3.563L16 18.875l5.672 3.563L16 26Z',
    }),
  );
});
dropboxSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var dropbox = {
  category: 'brand',
  colorable: false,
  name: 'dropbox',
  svg: dropboxSvg,
};
